import React from 'react';
import { Wordmark } from '../../shared/ui';

/** Mise en page des écrans d'accès (connexion, mot de passe) : identité à gauche, formulaire à droite. */
export const CadreAuth: React.FC<{ titre: string; sousTitre?: string; children: React.ReactNode }> = ({ titre, sousTitre, children }) => (
  <div className="min-h-screen supports-[min-height:100dvh]:min-h-dvh grid lg:grid-cols-[1.1fr_1fr]">
    <section className="hidden lg:flex flex-col justify-between bg-petrol-700 text-white p-12">
      <Wordmark inverse />
      <div className="max-w-md">
        <p className="text-3xl font-extrabold tracking-tight leading-tight">Le service après-vente des installateurs KLY.</p>
        <p className="mt-4 text-petrol-100/80 leading-relaxed">Dossiers, garanties constructeur, échanges avec les clients : tout ce qui arrive sur sav@ et assistance@ passe par ici.</p>
      </div>
      <p className="text-sm text-petrol-100/60">KLY Groupe · Gennevilliers</p>
    </section>
    <section className="flex items-center justify-center px-4 py-8 sm:p-12 bg-papier">
      <div className="w-full max-w-sm">
        <div className="lg:hidden mb-8 sm:mb-10"><Wordmark /></div>
        <h1 className="text-2xl font-extrabold tracking-tight text-encre">{titre}</h1>
        {sousTitre && <p className="mt-1 text-graphite">{sousTitre}</p>}
        {children}
      </div>
    </section>
  </div>
);

export const CHAMP_AUTH = 'w-full px-3.5 py-3 bg-white border border-trait rounded-lg text-encre placeholder:text-graphite/70 focus:outline-none focus:border-sapin-600 focus:ring-2 focus:ring-sapin-600/20 transition-colors';
export const BOUTON_AUTH = 'w-full py-3 bg-sapin-700 hover:bg-sapin-800 text-white font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2';

export default CadreAuth;
